import styled from 'styled-components';

export const Container = styled.section`
  align-items: center;
  display: flex;
  font-family: 'Roboto', sans-serif;
  font-size: 30px;
  height: 47px;
`;
Container.displayName = 'Container';

export const ColorsContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: 6px;
  width: 100%;
`;
ColorsContainer.displayName = 'ColorsContainer';

export const ColorsItem = styled.div`
  flex-grow: 1;
`;
ColorsItem.displayName = 'ColorsItem';

export const Logo = styled.img``;
Logo.displayName = 'Logo';

export const LogoContainer = styled.div`
  align-items: center;
  display: flex;
  height: 66px;
  justify-content: center;
  margin: 0 4px;
  width: 66px;
`;
LogoContainer.displayName = 'LogoContainer';

export const Points = styled.div`
  background-color: #ffffff;
  color: #040308;
  font-size: 48px;
  font-style: normal;
  font-weight: 600;
  line-height: 56px;
  min-width: 52px;
  text-align: center;
`;
Points.displayName = 'Points';

export const TeamColorsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
TeamColorsContainer.displayName = 'TeamColorsContainer';

export const TeamContainer = styled.div`
  align-items: center;
  background: #040308;
  display: flex;
  height: 56px;
  overflow: hidden;
  z-index: 1;
`;
TeamContainer.displayName = 'TeamContainer';

export const TeamLogo = styled.img`
  height: 50px;
  margin: 0 8px;
`;
TeamLogo.displayName = 'TeamLogo';

export const TeamName = styled.div`
  color: #ffffff;
  font-size: 36px;
  font-style: normal;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 50px;
  min-width: 104px;
  padding: 0 16px;
  position: relative;
  text-align: center;
`;
TeamName.displayName = 'TeamName';

export const Timer = styled.div`
  color: #040308;
  flex: 1;
  font-size: 48px;
  font-style: normal;
  font-weight: 800;
  letter-spacing: 0;
  line-height: 56px;
  text-align: center;
`;
Timer.displayName = 'Timer';

export const TimerContainer = styled.div`
  align-items: center;
  background-color: #f1be48;
  display: flex;
  height: 56px;
  justify-content: center;
  min-width: 166px;
`;
TimerContainer.displayName = 'TimerContainer';
